<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.rest_home.edit"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createCategoryProduct" hide-footer>
          <template v-slot:modal-title>Nova categoria</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            Categorias dos produtos
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="categoryProducts"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal update categoryProduct -->
              <b-modal :id="`categoryProduct_${String(item.id)}`" hide-footer>
                <template v-slot:modal-title>Editar categoria</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay
                      :show="loadingCategoryProductUpdate"
                      opacity="0.99"
                    >
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.rest_home.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              v-if="permissions.rest_home.edit"
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) =>
                                  deleteCategoryProduct(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar a categoria? <hr /> Só pode apagar caso não exista vinculo da categoria com produto!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal update categoryProduct -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "CategoryProduct",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      categoryProducts: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingCategoryProductUpdate: false,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalCategoryProduct(item.id);
      this.$bvModal.show(`categoryProduct_${String(item.id)}`);
    },
    retrieve() {
      this.permissions = adminData().permissions;

      this.getCategoryProducts();
    },
    async getCategoryProducts(page = 1) {
      try {
        this.loading = true;

        let params = {
          page,
        };

        const response = await api.get(
          "/admin/standard/category/product/paginate",
          {
            params,
          }
        );

        const { categories } = response.data;

        this.categoryProducts = categories;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name } = this;

        let params = { name };

        const response = await api.post(
          "/admin/standard/category/product/create",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createCategoryProduct");
          this.name = "";
          this.getCategoryProducts();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("createCategoryProduct");
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = { id, name };

        const response = await api.put(
          "/admin/standard/category/product/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`categoryProduct_${String(id)}`);
          this.getCategoryProducts();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleModalCategoryProduct(id) {
      try {
        this.loadingCategoryProductUpdate = true;

        this.id = id;

        const response = await api.get("/admin/standard/category/product/get", {
          params: { id },
        });

        const { category } = response.data;

        this.id = category.id;
        this.name = category.name;
        this.loadingCategoryProductUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteCategoryProduct(dialog, category) {
      try {
        const { id } = category;

        let data = { id };

        const response = await api.delete(
          "/admin/standard/category/product/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.getCategoryProducts();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>